import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './Navigation.css';

function Navigation({ scrolled }) {
  const [isOpen, setIsOpen] = useState(false);
  const [aboutDropdown, setAboutDropdown] = useState(false);
  const [whatWeDoDropdown, setWhatWeDoDropdown] = useState(false);
  const navigate = useNavigate();
  const { language, toggleLanguage } = useLanguage();

  const handleNavClick = (path) => {
    // Add /en prefix if in English mode
    const finalPath = language === 'en' ? `/en${path}` : path;
    navigate(finalPath);
    setIsOpen(false);
    window.scrollTo(0, 0);
  };

  return (
    <nav className={`navigation ${scrolled ? 'scrolled' : ''} ${isOpen ? 'menu-open' : ''}`}>
      <div className="nav-container">
        <Link to={language === 'en' ? '/en' : '/'} className="nav-logo" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }}>
          <img src="/logo.png" alt="Tabia Group" className="nav-logo-img" />
        </Link>
        
        <div className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <div 
            className="nav-dropdown"
            onMouseEnter={() => setAboutDropdown(true)}
            onMouseLeave={() => setAboutDropdown(false)}
          >
            <Link to={language === 'en' ? '/en/grupo' : '/grupo'} onClick={() => handleNavClick('/grupo')}>
              {language === 'en' ? 'Group' : 'Grupo'}
            </Link>
            <div className={`dropdown-menu ${aboutDropdown ? 'active' : ''}`}>
              <Link to={language === 'en' ? '/en/activos' : '/activos'} onClick={() => handleNavClick('/activos')}>
                {language === 'en' ? 'Assets' : 'Activos'}
              </Link>
              <Link to={language === 'en' ? '/en/equipo' : '/equipo'} onClick={() => handleNavClick('/equipo')}>
                {language === 'en' ? 'Team' : 'Equipo'}
              </Link>
            </div>
          </div>
          
          <div 
            className="nav-dropdown"
            onMouseEnter={() => setWhatWeDoDropdown(true)}
            onMouseLeave={() => setWhatWeDoDropdown(false)}
          >
            <span className="nav-dropdown-label" tabIndex={0} role="button" aria-haspopup="true">
              {language === 'en' ? 'What We Do' : 'Qué Hacemos'}
            </span>
            <div className={`dropdown-menu ${whatWeDoDropdown ? 'active' : ''}`}>
              <Link to={language === 'en' ? '/en/gestion' : '/gestion'} onClick={() => handleNavClick('/gestion')}>
                {language === 'en' ? 'Management' : 'Gestión'}
              </Link>
              <Link to={language === 'en' ? '/en/inmobiliaria' : '/inmobiliaria'} onClick={() => handleNavClick('/inmobiliaria')}>
                {language === 'en' ? 'Real Estate' : 'Inmobiliaria'}
              </Link>
            </div>
          </div>
          <Link to={language === 'en' ? '/en/medios' : '/medios'} onClick={() => handleNavClick('/medios')}>
            {language === 'en' ? 'Media' : 'Medios'}
          </Link>
          <Link to={language === 'en' ? '/en/contacto' : '/contacto'} onClick={() => handleNavClick('/contacto')}>
            {language === 'en' ? 'Contact' : 'Contacto'}
          </Link>
          
          <button className="language-toggle" onClick={toggleLanguage}>
            {language === 'es' ? 'EN' : 'ES'}
          </button>
        </div>

        <div className={`nav-toggle ${isOpen ? 'active' : ''}`} onClick={() => setIsOpen(!isOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;
